module.exports = __webpack_public_path__ + "static/media/default.9cff2df1.svg";